module.exports = __webpack_public_path__ + "static/media/icon-track-assignment-leaderboard.333c85ca.svg";